import Table from "../components/individual-handling-confirmation/Table";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import SearchBar from "../components/individual-handling-confirmation/SearchBar";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/hook";
import { stringToBoolean } from "../components/default-constants";
import {
  INITIAL_SEARCH_CRITERIA,
  setSearchCriteria,
} from "../features/slices/individual-handling-list";

/**
 * 個別取扱確認結果一覧
 */
const IndividualHandlingConfirmation = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.INDIVIDUAL_COUNSELING);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const isBackFromDetail = stringToBoolean(query.get("isBackFromDetail"));
  const [skip, setSkip] = useState(false);

  useEffect(() => {
    if (!isBackFromDetail) {
      dispatch(setSearchCriteria(INITIAL_SEARCH_CRITERIA));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SpaceBetween size="l">
      <SearchBar setSkip={setSkip} />
      <Table isBackFromDetail={isBackFromDetail} skip={skip} />
    </SpaceBetween>
  );
};

export default IndividualHandlingConfirmation;
